/**
 * The user's own menu settings, kept in this browser:
 *   {moves, sectionNames, sectionSummaries, pageNames, pageSummaries, customSections,
 *    starred: [{name, params}], recent: [{name, params}]}
 * See applyMenuSettings, toggleStar and rememberPage in @/nav-helpers.
 */
const STORAGE_KEY = 'k.fed-nav-settings-v1';

const emptySettings = () => ({
  moves: {}, sectionNames: {}, sectionSummaries: {}, pageNames: {}, pageSummaries: {}, customSections: [],
  starred: [], recent: [],
});

export function loadNavSettings() {
  try {
    const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
    return {...emptySettings(), ...saved};
  } catch (e) {
    console.warn('could not read the menu settings', e);
    return emptySettings();
  }
}

const NEW_MENU_KEY = 'k.fed-new-menu';

/** the menu in columns is opt in, per browser, from the old menu */
export function loadUseNewMenu() {
  try {
    return window.localStorage.getItem(NEW_MENU_KEY) === 'true';
  } catch (e) {
    return false;
  }
}

export function saveUseNewMenu(useNewMenu) {
  try {
    window.localStorage.setItem(NEW_MENU_KEY, String(useNewMenu));
  } catch (e) {
    console.warn('could not save the menu choice', e);
  }
}

export function saveNavSettings(settings) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch (e) {
    console.warn('could not save the menu settings', e);
  }
}
